import React, {Component} from 'react';
import dingdingImg from '../../images/ic_dingding@2x.png'
import workWechatImg from '../../images/ic_qiyeweixin@2x.png'
import wechatImg from '../../images/ic_weixin@2x.png'
import feishuImg from '../../images/ic_feishu@2x.png'
import ssoImg from '../../images/ic_dandiandenglu@2x.png'
import './index.css'

export default class LoginModeBtn extends Component {

    constructor(props) {
        super(props); 
        this.state={
            ...props
        }
        props.modeBtnShow && (this.state = props.modeBtnShow)
    }

    render() {
        const {changeContModePage, isCorp, customLoginConfig} = this.props
        const {dingdingShow, workWechatShow, wechatShow, feishuShow, qyWechatShow, qyzjWechatShow, ssoShow} = this.state
        return (
            <div className="LoginModeBtn">
                {(isCorp && window.data_config.hassso && customLoginConfig && customLoginConfig.hasSSOLogin) && <div className={`ssoBtn modeBtn ${!ssoShow ? "select" : ""}`} onClick={changeContModePage("LoginSSOShow")}><img src={ssoImg} alt=""/></div>}
                {(!isCorp && window.data_config.dingdingLogin) && <div onClick={changeContModePage("LoginDingdingCodeShow")} className={`dingdingBtn modeBtn ${!dingdingShow ? "select" : ""}`}><img src={dingdingImg} alt=""/></div>}
                {(!isCorp && window.data_config.qywxLogin) && <div onClick={changeContModePage("LoginWorkWechatShow")} className={`workWechatBtn modeBtn ${!workWechatShow ? "select" : ""}`}><img src={workWechatImg} alt=""/></div>}
                {!isCorp && (window.data_config.qywecat_login || window.data_config.qywecat_zj_login) && <div onClick={changeContModePage("LoginZJQyWechatShow")} className={`qyWechatBtn modeBtn ${(!qyWechatShow || !qyzjWechatShow) ? "select" : ""}`}><img src={workWechatImg} alt=""/><span className="self-qywechat">{React.language('self.build')}</span></div>}
                {/* {(window.data_config.qywecat_zj_login) && <div onClick={changeContModePage("LoginZJQyWechatShow")} className={`qyWechatBtn modeBtn ${!qyzjWechatShow ? "select" : ""}`}><img src={workWechatImg} alt=""/><span className="self-qywechat">{React.language('self.build')}</span></div>} */}
                {(window.data_config.weixinLogin && customLoginConfig && customLoginConfig.hasAccountLogin) && <div onClick={changeContModePage("LoginWechatShow")} className={`wechatBtn modeBtn ${!wechatShow ? "select" : ""}`}><img src={wechatImg} alt=""/></div>}
                {(!isCorp && window.data_config.hasfeishu) && <div onClick={changeContModePage("LoginFeishuShow")} className={`feishuBtn modeBtn ${!feishuShow ? "select" : ""}`}><img src={feishuImg} alt=""/></div>}
            </div>
        );
    }
}

